module.exports = __webpack_public_path__ + "media/images/riders/THOMAS_LITSCHER-96f4bf85109fe921faace8971a9dccd3.png";